<template>
    <section class="table pb70">
        <div class="box">
            <div class="table__header">
                <h1>{{ title }}</h1>
                <div class="btns">
                    <router-link class="btn" :to="{ name: 'roleList' }">
                        <i class="fal fa-backspace"></i>
                    </router-link>
                </div>
            </div>

            <div class="table__form">
                <div class="form_inline">
                    <label>Nome</label>
                    <input type="text" v-model="role.role" />
                </div>

                <div class="form_inline" v-if="role.id !== 1" style="align-items: flex-start;">
                    <label style="position: sticky; top: 20px; z-index: 2;">Permessi</label>
                    <div class="permissions">
                        <div
                            v-for="(module, index) in permissionsList"
                            :key="index"
                            class="permission-module"
                        >

                            <div class="form_inline" style="justify-content: space-between;">
                                <div class="w-25 mr-2">
                                    <strong class="label-form">{{ module.name }}</strong>
                                </div>
                                <div class="checkbox-wrapper-6">
                                    <input
                                        class="tgl tgl-light"
                                        type="checkbox"
                                        :id="'module-' + index"
                                        :checked="isModuleEnabled(module.name)"
                                        @change="toggleModule(module.name)"
                                    />
                                    <label class="tgl-btn" :for="'module-' + index"></label>
                                </div>
                            </div>



                            <div
                                v-if="isModuleEnabled(module.name) && module.actions"
                                class="module-actions ml20"
                            >


                                <div
                                    v-for="action in module.actions"
                                    :key="action"
                                    class="form_inline" style="justify-content: space-between;">
                                    <div class="w-25 mr-2">
                                        <strong class="label-form">{{ action }}</strong>
                                    </div>
                                    <div
                                        class="checkbox-wrapper-6"
                                        style="display: inline-block;"
                                    >
                                        <input
                                            class="tgl tgl-light"
                                            type="checkbox"
                                            :id="'module-' + index + '-action-' + action"
                                            :checked="getPermission(module.name, action)"
                                            @change="togglePermission(module.name, action)"
                                        />
                                        <label class="tgl-btn" :for="'module-' + index + '-action-' + action"></label>
                                    </div>

                                </div>




                            </div>
                        </div>
                    </div>
                </div>

                <div class="bcm_action" style="display: flex; justify-content: space-between;">
                    <div>
                        <div>
                            <div><strong>Created</strong>: {{ role.requestLogCreate }}</div>
                        </div>
                        <div>
                            <div><strong>Updated</strong>: {{ role.requestLogUpade }}</div>
                        </div>
                    </div>
                    <input type="button" :value="btn" @click="saveRole()" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            title: 'Ruolo',
            permissionsList: [
                { name: 'Projects', actions: ['insert', 'edit', 'delete', 'readonly', 'chanel'] },
                { name: 'ScriptTypes', actions: ['insert', 'edit', 'delete'] },
                { name: 'Libraries', actions: ['insert', 'edit', 'delete'] },
                { name: 'Languages', actions: ['insert', 'edit', 'delete'] },
                { name: 'Translations' },
                { name: 'Settings' },
                { name: 'Users', actions: ['insert', 'edit', 'delete'] },
                { name: 'Roles', actions: ['insert', 'edit', 'delete'] },
            ],
        }
    },

    computed: {
        ...mapGetters({
            role: 'rolesModule/role',
            hasPermission: 'hasPermission'
        }),
        btn() {
            return this.$route.params.action === 'create' ? 'Save' : 'Update'
        },
    },

    methods: {

        createRole () {
            this.$store.state.rolesModule.role.requestLogCreate = '/';
            this.$store.state.rolesModule.role.requestLogUpade = '/';
        },
        isModuleEnabled(moduleName) {
            return (
                this.role &&
                this.role.privilegies &&
                this.role.privilegies[moduleName] !== undefined
            )
        },

        toggleModule(moduleName) {
            if (!this.role.privilegies) {
                this.$set(this.role, 'privilegies', {});
            }

            const current = this.role.privilegies[moduleName];

            if (current && typeof current === 'object') {
                this.$delete(this.role.privilegies, moduleName);
            } else {
                this.$set(this.role.privilegies, moduleName, {});
            }
        },

        getPermission(module, action) {
            return (
                !!this.role.privilegies &&
                !!this.role.privilegies[module] &&
                !!this.role.privilegies[module][action]
            )
        },

        togglePermission(module, action) {
            if (!this.role.privilegies) {
                this.$set(this.role, 'privilegies', {});
            }

            // Ensure module is an object, not an array
            if (!this.role.privilegies[module] || typeof this.role.privilegies[module] !== 'object') {
                this.$set(this.role.privilegies, module, {});
            }

            const current = this.role.privilegies[module][action] === true;
            this.$set(this.role.privilegies[module], action, !current);
        },

        loadRole() {
            this.$store.dispatch('rolesModule/loadRole', {
                urlToConnect: 'roles/' + this.$route.params.id + '/edit',
                id: this.$route.params.id,
            })
        },

        saveRole() {
            // Assicurati che privilegies sia un oggetto valido
            const privilegies = this.role.privilegies && typeof this.role.privilegies === 'object'
                ? this.role.privilegies
                : {};

            const parameters = {
                urlToConnect: 'roles',
                methodToConnect: 'post',
                role: this.role.role,
                privilegies: JSON.parse(JSON.stringify(privilegies)), // Deep clone per sicurezza
            }

            if (this.$route.params.action === 'edit') {
                parameters.urlToConnect = 'roles/' + this.$route.params.id;
                parameters._method = 'patch';
            }

            this.$store.dispatch('rolesModule/saveRole', parameters).then((data) => {
                if (this.$route.params.action === 'create') {
                    if(this.hasPermission('Roles', 'edit')){
                        this.$router.replace("/roles/" +data.id+ "/edit")
                    } else {
                        this.$router.replace("/roles")
                    }
                }
            });
        }
    },

    watch: {
        $route() {
            if (this.$route.params.action === 'edit') {
                this.loadRole()
            } else if(this.$route.params.action == 'create') {
                this.createRole()
            }
        },
    },

    created() {
        if (this.$route.params.action === 'edit') {
            this.loadRole()
        } else if(this.$route.params.action == 'create') {
            this.createRole()
        }
    },
}
</script>